import React, { ReactElement } from 'react';

import { Image } from 'components/lib';

export interface SchoolLogoProps {
  logoUrl: string;
}

export const SchoolLogo = ({ logoUrl }: SchoolLogoProps): ReactElement => (
  <Image
    src={logoUrl || '/img/schoolLogoPlaceholder.svg'}
    alt={logoUrl || 'School Logo Placeholder'}
    style={{
      maxWidth: 200,
    }}
  />
);
